var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKycAndCdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.7904 5.4165V8.12484H16.2487C13.2614 8.12484 10.832 10.5542 10.832 13.5415V54.1665C10.832 57.1538 13.2614 59.5832 16.2487 59.5832H37.2594L31.8428 54.1665H16.2487V13.5415H29.7904V16.2498H35.207V13.5415H48.7487V48.0939L54.1654 42.6772V13.5415C54.1654 10.5542 51.736 8.12484 48.7487 8.12484H35.207V5.4165H29.7904ZM32.4987 24.3748C31.0621 24.3748 29.6844 24.9455 28.6685 25.9613C27.6527 26.9772 27.082 28.3549 27.082 29.7915C27.082 31.2281 27.6527 32.6058 28.6685 33.6217C29.6844 34.6375 31.0621 35.2082 32.4987 35.2082C33.9353 35.2082 35.313 34.6375 36.3289 33.6217C37.3447 32.6058 37.9154 31.2281 37.9154 29.7915C37.9154 28.3549 37.3447 26.9772 36.3289 25.9613C35.313 24.9455 33.9353 24.3748 32.4987 24.3748ZM32.4987 37.9165C26.581 37.9165 21.6654 40.3778 21.6654 43.9203V46.0415H43.332V43.9203C43.332 40.3778 38.4164 37.9165 32.4987 37.9165ZM60.3755 44.1266L48.7487 55.7534L42.5386 49.5433L38.7088 53.373L48.7487 63.4129L64.2052 47.9564L60.3755 44.1266Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKycAndCdd);
export default __webpack_public_path__ + "static/media/kyc-and-cdd.756c64bf24db05ba0eb812566ac80d61.svg";
export { ForwardRef as ReactComponent };